import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RegistrationForm } from '@/components/dialogs/Registration/components/RegistrationForm';
import { StaticModal, type StaticModalProps } from '@/components/StaticModal';
import { getCDNImageUrl } from '@/helpers/cdn';

import { ScWheelRegistration } from './styled';

interface PrivacyPolicyProps extends StaticModalProps {
  translation: string;
}

interface ModalContent {
  title: string;
  subTitle: string;
  main: string;
  button: string;
  code?: string;
}

export const WheelRegistrationModal: FC<PrivacyPolicyProps> = ({
  onClose,
  translation,
}) => {
  const {
    i18n: { language },
    t,
  } = useTranslation([translation, 'common']);

  const modalContent = t('modalContent', {
    returnObjects: true,
  }) as ModalContent[];

  const regImg = useMemo(() => {
    if (language === 'de') {
      return 'reg-img-de.png';
    }
    if (language === 'en') {
      return 'reg-img-en.png';
    }

    return 'reg-img-aucanz.png';
  }, [language]);

  return (
    <StaticModal
      bgTransparent
      hideCloseBtn
      isPortal={true}
      maxWidth={992}
      onClose={onClose}
    >
      <ScWheelRegistration>
        <div className="promo-box">
          <div className="offer">
            <span
              dangerouslySetInnerHTML={{
                __html: modalContent[1].main,
              }}
            />
          </div>
          <img
            alt="wheel"
            src={getCDNImageUrl(`/lp/wheel-fortune/${regImg}`)}
          />
        </div>
        <div className="reg-box">
          <h2 className="reg-title">{t('auth.registration.title')}</h2>
          <RegistrationForm isOneStepRegistration />
        </div>
      </ScWheelRegistration>
    </StaticModal>
  );
};
